import { createThemedUseStyles } from "theme";
import { FilterDropdownProps } from ".";

export default createThemedUseStyles(theme => ({
  filter: {
    color: (props: FilterDropdownProps) =>
      props.isActive ? theme.pallette.blue : theme.pallette.black
  }
}));
